import React, { useState } from 'react';
import { FaShoppingCart, FaHeart, FaSearch, FaTimes } from "react-icons/fa";
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useLazySearchproductsQuery } from '../redux/Api/api';

const BottomBar = () => {
  const navigate = useNavigate();
  const selecttor = useSelector(state => state?.cartcount);
  const whishlistCount = useSelector(state => state?.wishlistCount);
  
  const [showSearch, setShowSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchProducts] = useLazySearchproductsQuery();

  const performSearch = (value) => {
    setIsSearching(true);
    searchProducts(value)
      .unwrap()
      .then(res => {
        if (res?.result?.length > 0) {
          setSearchResults(res.result);
          setShowDropdown(true);
        } else {
          setSearchResults([]);
          setShowDropdown(false);
        }
      })
      .catch(err => {
        console.error('Search Error:', err);
        setSearchResults([]);
        setShowDropdown(false);
      })
      .finally(() => {
        setIsSearching(false);
      });
  };

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchTerm(value);

    if (!value.trim()) {
      setShowDropdown(false);
      setSearchResults([]);
      return;
    }

    const timeoutId = setTimeout(() => {
      performSearch(value);
    }, 300);

    return () => clearTimeout(timeoutId);
  };

  const handleSearchSubmit = () => {
    if (!searchTerm.trim()) {
      toast.warning('Please enter a search term.');
      return;
    }
    performSearch(searchTerm);
  };

  const handleProductClick = (product) => {
    setShowDropdown(false);
    setSearchTerm('');
    setShowSearch(false);
    navigate('/productview', { state: product });
  };

  return (
    <>
      {showSearch && (
        <div className="fixed inset-0 bg-white z-50 p-4">
          <div className="relative w-full">
            <div className="flex mb-4">
              <input
                type="search"
                placeholder="Search for products"
                className="border-2 border-blue-500 p-3 w-full rounded-l-md"
                value={searchTerm}
                onChange={handleSearchChange}
              />
              <button
                className="bg-blue-600 text-white px-6 py-3 rounded-r-md flex items-center hover:bg-blue-700 transition-colors"
                onClick={handleSearchSubmit}
                disabled={isSearching}
              >
                {isSearching ? (
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                ) : (
                  <FaSearch />
                )}
              </button>
            </div>
            <button
              onClick={() => setShowSearch(false)}
              className="absolute -top-2 right-0 p-2"
            >
              <FaTimes size={24} className="text-gray-600" />
            </button>

            {/* Search Results */}
            {showDropdown && searchResults.length > 0 && (
              <div className="bg-white border border-gray-200 shadow-lg rounded-md max-h-[calc(100vh-200px)] overflow-y-auto">
                {searchResults.map((product) => (
                  <div
                    key={product._id}
                    className="p-3 hover:bg-gray-50 cursor-pointer border-b border-gray-100 last:border-b-0"
                    onClick={() => handleProductClick(product._id)}
                  >
                    <div className="flex items-center">
                      <img
                        src={product.image}
                        alt={product.name}
                        className="w-16 h-16 object-cover rounded-md mr-4"
                      />
                      <div className="flex-1">
                        <h3 className="font-semibold text-gray-800 mb-1">{product.name}</h3>
                        <p className="text-sm text-gray-600">${product.price}</p>
                        {product.category && (
                          <p className="text-xs text-gray-500 mt-1">
                            Category: {product.category}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Bottom  Bar */}
      <div className="fixed bottom-0 left-0 w-full bg-white shadow-md border-t border-gray-200 flex justify-around py-3 md:hidden">
        <button className="flex flex-col items-center text-blue-600 hover:text-blue-500">
          <Link to="/cart" className="relative">
            <FaShoppingCart size={24} />
            <span className="text-xs mt-1">Cart</span>
            {selecttor > 0 && (
              <span className="absolute top-0 left-3 bg-red-500 text-white rounded-full px-2 text-xs">
                {selecttor}
              </span>
            )}
          </Link>
        </button>

        <button className="flex flex-col items-center text-blue-600 hover:text-blue-500">
          <Link to="/wishlist" className="relative">
            <FaHeart size={24} />
            <span className="text-xs mt-1">Wishlist</span>
            {whishlistCount > 0 && (
              <span className="absolute top-0 left-3 bg-red-500 text-white rounded-full px-2 text-xs">
                {whishlistCount}
              </span>
            )}
          </Link>
        </button>

        <button 
          className="flex flex-col items-center text-blue-600 hover:text-blue-500"
          onClick={() => setShowSearch(true)}
        >
          <FaSearch size={24} />
          <span className="text-xs mt-1">Search</span>
        </button>
      </div>
    </>
  );
};

export default BottomBar;